import InviteNotification from "./InviteNotification";
import A from './ActionCreators.js';
import NotificationsIcon from './svg/Notification.svg';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import G from './Getters';


import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';



function NotificationList(){

}


export default function AppNotifications(){

  const [anchorEl, setAnchorEl] = useState(null);
  const [ open, setOpen ] = useState(false);
  const dispatch = useDispatch();

  let invites = useSelector(state => G.getInvites(state))

  let unseenInvites = useSelector(state => G.getInvites(state,{unseen:true}))

  console.log("us",unseenInvites);

  useEffect(() => {

    if( anchorEl && Object.keys(unseenInvites).length > 0 ){

      dispatch(A.setItemsAsSeen({

        invites:unseenInvites.map(x => x._id)

      }))


    }

  },[anchorEl,unseenInvites,dispatch])


  const notification = invites.map(invite => {
    return {
      text:(
        <span>
          <b><u>{invite.inviterEmail}</u></b> invited you to join their group.
          <span style={{
            fontSize:10
          }}>
          {false && JSON.stringify(invite)}
          </span>
        </span>
      ),
      invite,
    }
  })



  let noNotificationMessage = invites.length === 0 && (
    <MenuItem
    disableRipple
    >
      No notifications to show.
    </MenuItem>

  )



  let notifactionBubble = Object.keys(unseenInvites).length ? (
    <div style={{
      position:'absolute',
      top:-5,
      right:-8,
      padding:2,
      background:'red',
      height:15,
      minWidth:15,
      color:'white',
      borderRadius:5,
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      fontWeight:'bold',
    }}>
      <div>{unseenInvites.length}</div>
    </div>
  ) : null


  return (

    <>
      <div onClick={e => {
        setAnchorEl(e.target);
      }} class="hoverable round-corners rel">
        <img src={NotificationsIcon}/>
        {notifactionBubble}
      </div>

      {anchorEl && <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        closeOnOutsideClick={true}
        style={{transform:'translate(0,20px)'}}
        onClose={() => setAnchorEl(null)}>
        {noNotificationMessage}
        {notification.map((menuItem,ii) => {
          return (
            <>
              {ii > 0 && (
                <div style={{width:'100%', height:1, background:'#ccc'}}/>
              )}
            <InviteNotification {...{
              setOpen,
                setAnchorEl,
                menuItem,
            }}/>
            </>
          )
          
        })}
      </Menu>}
    </>


  )
}
